import React, { FC } from 'react'
import DescriptionItem from './DescriptionItem'
import { DescriptionListProps } from './type';

export const DescriptionList: FC<DescriptionListProps> = ({ description }) => {

  const renderList = () => {
    return description.map((des, ind) => {
      return <DescriptionItem {...(des || {})} key={ind}/>
    })
  }

  const renserItem = () => {
    return <DescriptionItem {...(description || {})} />
  }

  return (
    <div>
      {Array.isArray(description) ? renderList() : renserItem()}
    </div>
  );
}
  
export default DescriptionList